import React, { useEffect, useState } from 'react';
import { Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import SimpleBar from "simplebar-react";
import config from '../../config';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationList, readNotification, readBulkNotification } from '../../slices/thunks';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const NotificationDropdown = ({ user }) => {
    const dispatch = useDispatch();
    const [webSocket, setWebSocket] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
    const [activeTab, setActiveTab] = useState('1');

    const toggleNotificationDropdown = () => {
        setIsNotificationDropdown(!isNotificationDropdown);
    };

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    useEffect(() => {
        if (webSocket && webSocket.readyState !== WebSocket.CLOSED) {
            webSocket.close();
        }
    
        if (user?._id) {
            const ws = new WebSocket(`${config.api.REACT_APP_SPED_MESSAGE_API_WS_URL}/notification/ws/${user._id}`);    
            // ws.onopen = () => console.log('WebSocket conectado');
            // ws.onerror = (error) => console.error('WebSocket error:', error);
            // ws.onclose = () => console.log('WebSocket desconectado');    
            setWebSocket(ws);
    
            return () => {
                if (ws && ws.readyState !== WebSocket.CLOSED) {
                    ws.close();
                }
            };
        }
    }, [user]);
    

    useEffect(() => {
        if (webSocket) {
            webSocket.addEventListener('open', () => {
                console.log('WebSocket connected');
                webSocket.send('WS connection established');
            });

            webSocket.addEventListener('message', (event) => {
                try {
                    if (user?._id) {
                        dispatch(getNotificationList({ user_id: user._id }));
                    }
                } catch (err) {
                    console.error('Error parsing WebSocket message:', err);
                }
            });

            webSocket.addEventListener('close', () => {
                console.log('WebSocket disconnected');
            });

            webSocket.addEventListener('error', (error) => {
                // console.error('WebSocket error:', error);
            });

            return () => {
                webSocket.close();
            };
        }
    }, [webSocket, user, dispatch]);


    const selector = createSelector(
        state => state.Notifications,
        result => ({
            itemNotificationList: result.itemNotificationList,
            requireCloseModal: result.requireCloseModal,
        })
    );
    const { itemNotificationList } = useSelector(selector);

    useEffect(() => {
        if (user?._id) {
            dispatch(getNotificationList({ user_id: user._id }));
        }
    }, [user]);

    useEffect(() => {
        if (itemNotificationList) {
            setNotifications(itemNotificationList);
        }
    }, [itemNotificationList]);

    const handleMarkAsRead = (id) => {
        dispatch(readNotification(id)).then(() => {
            setNotifications((prev) =>
                prev.map((notification) => notification._id === id ? { ...notification, read: true } : notification)
            );
        });
    };

    const handleMarkAllAsRead = () => {
        const unreadNotificationIds = notifications
            .filter(notification => !notification.read && notification._id)
            .map(notification => notification._id);


        if (unreadNotificationIds.length > 0) {
            dispatch(readBulkNotification(unreadNotificationIds)).then((response) => {

                if (response?.payload?.message) {
                    toast.success(response.payload.message, { autoClose: 3000 });
                }

                setNotifications((prev) =>
                    prev.map((notification) =>
                        unreadNotificationIds.includes(notification._id)
                            ? { ...notification, read: true }
                            : notification
                    )
                );
            });
        }
    };


    return (
        <React.Fragment>
            <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item d-none d-sm-flex">
                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                    <i className='bx bx-bell fs-22'></i>
                    {notifications.some(n => !n.read) && (
                        <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                            {notifications.filter(n => !n.read).length}
                        </span>
                    )}
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                    <div className="dropdown-head bg-primary bg-pattern rounded-top">
                        <div className="p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h6 className="m-0 fs-16 fw-semibold text-white">Notificaciones</h6>
                                </Col>
                                <Col className="text-end">
                                    {notifications.some(n => !n.read) && (
                                        <Button color="light" size="sm" onClick={handleMarkAllAsRead}>
                                            Marcar todas como leídas
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1" className="py-2 ps-2">
                            <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
                                {notifications.length > 0 ? notifications.map((notification, index) => (
                                    <div key={index} className="p-2 text-reset notification-item d-block dropdown-item position-relative">
                                        <div className="d-flex">
                                            <div className="avatar-xs me-3">
                                                <span className={`avatar-title rounded-circle fs-16`} style={{ width: "36px", height: "36px", backgroundColor: notification.notification_type?.bgcolor, color: notification.notification_type?.txcolor }}>
                                                    <i className={notification.notification_type?.icon}></i>
                                                </span>
                                            </div>
                                            <div className="flex-grow-1">
                                                <Link to={notification.url || "#"} className="stretched-link">
                                                    <h6 className={`mt-0 mb-1 fs-13 fw-semibold ${notification.read ? 'text-muted' : ''}`}>
                                                        {notification.title}
                                                    </h6>
                                                </Link>
                                                <p className="fs-13 text-muted m-0">{notification.message}</p>
                                                <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                                    <i className="mdi mdi-clock-outline"></i> <span className="fst-italic">{new Date(notification.creation_date).toLocaleString()}</span>
                                                </p>
                                            </div>
                                            <div className="px-2 fs-15">
                                                {!notification.read && (
                                                    <Button color="link" size="sm" onClick={() => handleMarkAsRead(notification._id)}>
                                                        <i className={`fs-16 ${Icons.check}`}></i>
                                                    </Button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )) : (
                                    <div className="text-center p-3">
                                        <p className="text-muted m-0 p-0">No hay notificaciones</p>
                                    </div>
                                )}
                            </SimpleBar>
                        </TabPane>
                    </TabContent>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default NotificationDropdown;
